import { formatMessage } from '../Localization/formatMessage';
import Messages from '../Localization/Messages';

export const getCommonInputFields = (state, setState, propertyName, errors, isMandatory) => {
  const handleChange = e => {
    setState({
      ...state,
      [e.target.name]: getValueForInputChange(state[e.target.name], e.target.value),
    });
  };

  return {
    name: propertyName,
    key: propertyName,
    onChange: handleChange,
    value: state[propertyName] ?? '',
    error: getErrorMessage(propertyName, errors),
    isMandatory: isMandatory,
  };
};

export const getErrorMessage = (inputId, errors) => {
  return errors.find(error => error.inputId === inputId)?.message;
};

export const createServerErrorMessage = (message, inputId = 'server') => {
  message = formatMessage(Messages.error_serverError, { message });
  return { inputId, message };
};

export const getServerErrorMessage = errors => {
  return errors.find(error => error.inputId === 'server')?.message;
};

export const hasFieldChangedValue = (edited, initial) => {
  if (typeof edited === 'boolean' || typeof initial === 'boolean') {
    if (initial == null) return edited;
    return edited !== initial;
  }

  // can handle integers and strings
  const trimmedEdited = edited?.toString()?.trim();
  if (initial == null) return !!trimmedEdited;
  return trimmedEdited !== initial?.toString()?.trim();
};

export const validateEmail = email => {
  //eslint-disable-next-line
  return (
    !email?.trim() ||
    /^(([\w!#$%&'*+\-/=?^_`{|}~]+(\s)*)|("([^"\\]|\\.)*"))?([\w!#$%&'*+\-/=?^_`{|}~.]+|"([^"\\]|\\.)*")@(([\w-]+\.)+[\w-]{2,}|(\[(25[0-5]|2[0-4]\d|[01]?\d?\d)(\.(25[0-5]|2[0-4]\d|[01]?\d?\d)){3}\]))$/.test(
      email
    )
  );
};

export const getValueForInputChange = (oldValue, newValue) => {
  if ((oldValue?.trim().length > 0 && newValue?.trim().length === 0) || newValue?.trim().length === 0) {
    return null;
  }
  return newValue;
};
